import React from 'react'
import {ActionButton} from "../../misc/buttons/action-button";
import {Image} from "../../image/image";
import styles from "./bookmaker-action-button.module.scss";
import classNames from "classnames";
import {useBetsImpression} from "../../../../infrastructure/hooks/useBetsImpression";

export const BookmakerActionButton = ({
                                        onClick,
                                        isSmallView,
                                        supportColor,
                                        bookmaker,
                                        logoClassName,
                                        label,
                                        className,
                                        bookmakerSrc,
                                        bookieHrefModel,
                                        betsImpressionParams,
                                        controller,
                                        withLogo,
                                        shouldRenderActionButton
                                      }) => {
  const canClickBookie = !!(bookieHrefModel && onClick);
  const ref = useBetsImpression(controller, betsImpressionParams)

  const containerProps = {
    ref,
    className: classNames(className, {[styles.clickable]: canClickBookie}, {[isSmallView]: styles.small_container}, styles.container),
    onClick: canClickBookie ? () => onClick?.() : undefined,
    style: {
      backgroundColor: supportColor ? bookmaker?.color : '',
      color: supportColor ? bookmaker?.bookmakerButtonTextColor : ''
    },
    bookieHrefModel
  };

  const logoProps = {
    className: classNames(logoClassName, styles.logo),
    src: bookmakerSrc || bookmaker?.srcBookmakerLogoImage,
    eager: true,
  };

  return (
      shouldRenderActionButton ? <ActionButton {...containerProps}>
      {
        label || bookmaker?.actionButton?.label
      }
      {
        withLogo ? <Image {...logoProps}/> : null
      }
    </ActionButton> : null
  )
};
